import { createAction } from '@reduxjs/toolkit';

export const CLEAR_PAYMENT_PLAN_PROPERTY_ADDRESS = 'PAYMENT_PLAN/CLEAR_PROPERTY_ADDRESS';

export const clearPaymentPlanPropertyAddress = createAction(CLEAR_PAYMENT_PLAN_PROPERTY_ADDRESS);
